export default "__VITE_ASSET__Cx0J66oK__"